import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import DriverList from './pages/DriverList';
import DriverForm from './pages/DriverForm';
import DriverDetails from './pages/DriverDetails';
import VehicleList from './pages/VehicleList';
import VehicleForm from './pages/VehicleForm';
import Assignments from './pages/Assignments';
import Salary from './pages/Salary';
import Employees from './pages/Employees';
import PaymentLinkGenerator from './pages/PaymentLinkGenerator';
import PaymentsReport from './pages/PaymentsReport';
import DriverRegistration from './pages/DriverRegistration';
import DriverQRCode from './pages/DriverQRCode';
import Attendance from './pages/Attendance';
import GSTInvoicing from './pages/GSTInvoicing';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/driver-registration" element={<DriverRegistration />} />
        
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <div className="flex">
                <Sidebar />
                <div className="flex-1 p-8 bg-gray-50 min-h-screen">
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/drivers" element={<DriverList />} />
                    <Route path="/drivers/new" element={<DriverForm />} />
                    <Route path="/drivers/:id/edit" element={<DriverForm />} />
                    <Route path="/drivers/:id" element={<DriverDetails />} />
                    <Route path="/vehicles" element={<VehicleList />} />
                    <Route path="/vehicles/new" element={<VehicleForm />} />
                    <Route path="/assignments" element={<Assignments />} />
                    <Route path="/salary" element={<Salary />} />
                    <Route path="/payments/generate" element={<PaymentLinkGenerator />} />
                    <Route path="/payments/reports" element={<PaymentsReport />} />
                    <Route path="/employees" element={<Employees />} />
                    <Route path="/qr-code" element={<DriverQRCode />} />
                    <Route path="/attendance" element={<Attendance />} />
                    <Route path="/invoicing" element={<GSTInvoicing />} />
                  </Routes>
                </div>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
